module.exports = __webpack_public_path__ + "img/ph2supp1.4d21d321.png";